interface Props {
  kind:
    | "pending"
    | "accepted"
    | "rejected"
    | "cancelled"
    | "active"
    | "inactive"
    | "current"
    | "archived"
    | "approved";
  children?: React.ReactNode;
}

export function Pill({ kind, children }: Props) {
  return <span className={`pill pill-${kind}`}>{children ?? kind}</span>;
}
